$('.back').click(function() {
    window.close();
});

